export const scheduleWaiting = {
  'schedule.waiting.title': 'Лист ожидания',
  'schedule.waiting.action': 'Лист ожидания',
  'schedule.waiting.new': 'Новая заявка',
  'schedule.waiting.edit': 'Изменить заявку',
  'schedule.waiting.unsaved': 'Заявка в лист ожидания',
  'schedule.waiting.status': 'Статус',
  'schedule.waiting.status.open': 'Открыта',
  'schedule.waiting.status.booked': 'Исполнена',
  'schedule.waiting.status.withdrawn': 'Отозвана',
  'schedule.waiting.anyPatient': 'Все пациенты',
  'schedule.waiting.clinician': 'Желаемый врач',
  'schedule.waiting.anyClinician': 'Любой врач',
  'schedule.waiting.from': 'Не раньше',
  'schedule.waiting.to': 'Не позже',
  'schedule.waiting.window': '{from} – {to}',
  'schedule.waiting.note': 'Пожелания',
  'schedule.waiting.missingInput': 'Выберите пациента, тип визита и подходящие дни; последний день не раньше первого.',
  'schedule.waiting.create': 'Добавить в лист ожидания',
  'schedule.waiting.save': 'Сохранить заявку',
  'schedule.waiting.book': 'Записать',
  'schedule.waiting.withdraw': 'Отозвать',
  'schedule.waiting.withdrawTitle': 'Отозвать заявку?',
  'schedule.waiting.withdrawDescription': 'Заявка останется в записях как отозванная. Приёмы не меняются.',
  'schedule.waiting.withdrawConfirm': 'Отозвать заявку',
  'schedule.waiting.created': 'Добавлено в лист ожидания',
  'schedule.waiting.saved': 'Заявка сохранена',
  'schedule.waiting.withdrawn': 'Заявка отозвана',
  'schedule.waiting.updated': 'Изменено {time}',
  'schedule.waiting.empty': 'Заявок нет',
  'schedule.waiting.emptyDetail': 'По этим фильтрам никто не ждёт.',
  'schedule.waiting.loading': 'Загрузка листа ожидания',
  'schedule.waiting.loadFailed': 'Не удалось загрузить лист ожидания',
  'schedule.waiting.more': 'Показать ещё',
  'schedule.sequence.title': 'Несколько визитов',
  'schedule.sequence.action': 'Несколько визитов',
  'schedule.sequence.unsaved': 'Несколько визитов по порядку',
  'schedule.sequence.from': 'Первый день',
  'schedule.sequence.span': 'Дней для поиска',
  'schedule.sequence.span.day': 'Один день',
  'schedule.sequence.span.week': 'Семь дней',
  'schedule.sequence.notBefore': 'Не раньше',
  'schedule.sequence.visits': 'Визиты по порядку',
  'schedule.sequence.visit': 'Визит {n}',
  'schedule.sequence.addVisit': 'Добавить визит',
  'schedule.sequence.removeVisit': 'Убрать визит {n}',
  'schedule.sequence.moveUp': 'Сдвинуть визит {n} раньше',
  'schedule.sequence.moveDown': 'Сдвинуть визит {n} позже',
  'schedule.sequence.limit': 'До восьми визитов в одной последовательности, в пределах семи дней.',
  'schedule.sequence.missingInput': 'Для поиска выберите пациента, первый день и тип визита для каждого визита.',
  'schedule.sequence.search': 'Подобрать время',
  'schedule.sequence.searching': 'Подбираем визиты по порядку',
  'schedule.sequence.failed': 'Не удалось выполнить подбор',
  'schedule.sequence.proposal': 'Предложенное время',
  'schedule.sequence.previewNote': 'Предложение ничего не резервирует, пока визиты не записаны.',
  'schedule.sequence.incomplete': 'Полная последовательность не найдена',
  'schedule.sequence.incompleteDetail': 'Ограниченный подбор не нашёл целого предложения. Измените дни, порядок или выбор ресурсов и повторите подбор.',
  'schedule.sequence.stale': 'Условия изменились. Повторите подбор перед записью.',
  'schedule.sequence.book': 'Записать все визиты',
  'schedule.sequence.visitFloor': 'Этот визит не раньше',
  'schedule.sequence.visitFloorDay': 'Этот визит не раньше, день',
  'schedule.sequence.floorNote': 'Собственное самое раннее время визита повторяет поиск всей последовательности; он и следующие визиты могут сдвинуться позже, чтобы сохранить порядок.',
  'schedule.sequence.floorInvalid': 'Самое раннее время визита должно существовать в часовом поясе клиники и приходиться на день в пределах поиска.',
} as const
